/* eslint-disable */
//tslint:disable

import { IAreaPartSchema } from '../area_part/AreaPartSchema';
import { IBargainTermsSchema } from '../bargain_terms/BargainTermsSchema';
import { IBookingInfoSchema } from './BookingInfoSchema';
import { IBuildingSchema } from '../building/BuildingSchema';
import { IBusinessShoppingCenterNewCardSchema } from '../business_shopping_center_new_card/BusinessShoppingCenterNewCardSchema';
import { ICommercialOwnershipSchema } from '../commercial_ownership/CommercialOwnershipSchema';
import { ICoworkingSchema } from './CoworkingSchema';
import { IDeadlineSchema } from '../deadline/DeadlineSchema';
import { IDrainageSchema } from './DrainageSchema';
import { IElectricitySchema } from './ElectricitySchema';
import { IExportLinksSchema } from '../export_links/ExportLinksSchema';
import { IFlagsSchema } from './FlagsSchema';
import { IESOfferFloorPlanSchema } from '../floor_plan/ESOfferFloorPlanSchema';
import { IGarageSchema } from './GarageSchema';
import { IGasSchema } from './GasSchema';
import { IGeoSchema } from '../geo/GeoSchema';
import { ISimpleVillageSchema } from '../village/SimpleVillageSchema';
import { ILandSchema } from '../land/LandSchema';
import { IModerationInfoSchema } from '../moderation_info_value_object/ModerationInfoSchema';
import { IMonthlyIncomeSchema } from '../monthly_income/MonthlyIncomeSchema';
import { INewBuildingSchema } from './NewBuildingSchema';
import { IPhoneSchema } from './PhoneSchema';
import { IPhotoSchema } from '../photo/PhotoSchema';
import { IPriceSchema } from '../price/PriceSchema';
import { IPublishTermsSchema } from '../publish_terms/PublishTermsSchema';
import { IOfferRosreestrCheckSchema } from '../offer_rosreestr_check/OfferRosreestrCheckSchema';
import { ICommercialSpecialtySchema } from '../commercial_specialty/CommercialSpecialtySchema';
import { ITrackingDataSchema } from './TrackingDataSchema';
import { IValueAddedServicesSchema } from '../value_added_services/ValueAddedServicesSchema';
import { IVideoSchema } from '../video/VideoSchema';
import { IWaterSchema } from './WaterSchema';
import { IWorkTimeInfoSchema } from './WorkTimeInfoSchema';

export interface IOfferSchema {
  /** Доступ **/
  accessType?: EAccessType | null;
  /** Дата добавления **/
  added?: string | null;
  additionalPhoneLinesAllowed?: boolean | null;
  /** Площадь комнат, м2 **/
  allRoomsArea?: string | null;
  /** Дата перемещения объявления в архив **/
  archivedDate?: string | null;
  /** Описание частей площади объявления **/
  areaParts?: IAreaPartSchema[] | null;
  /** Дата освобождения **/
  availableFrom?: string | null;
  /** Количество балконов **/
  balconiesCount?: number | null;
  /** Условия сделки **/
  bargainTerms?: IBargainTermsSchema | null;
  /** Количество спален **/
  bedroomsCount?: number | null;
  /** Количество спальных мест **/
  bedsCount?: number | null;
  /** Информация о бронировании **/
  booking?: IBookingInfoSchema | null;
  /** ID Застройщика, который отображается в объявлении от застройщика, если у ЖК несколько застройщиков **/
  builderId?: number | null;
  /** Id застройщиков **/
  buildersIds?: number[] | null;
  /** Информация о здании **/
  building?: IBuildingSchema | null;
  /** Кадастровый номер дома **/
  buildingCadastralNumber?: string | null;
  /** БЦ/ТЦ **/
  businessShoppingCenter?: IBusinessShoppingCenterNewCardSchema | null;
  /** Кадастровый номер **/
  cadastralNumber?: string | null;
  /** Тип подключенного calltracking-а **/
  callTrackingProvider?: ECallTrackingProvider | null;
  /** Можно частями **/
  canParts?: boolean | null;
  /** Кол-во грузовых лифтов **/
  cargoLiftsCount?: number | null;
  /** Список ID категории **/
  categoriesIds?: number[] | null;
  /** Категория объявления **/
  category: ECategory;
  /** Ссылка на сертификат **/
  certificate?: string | null;
  /** Можно с детьми **/
  childrenAllowed?: boolean | null;
  /** ID объявления на ЦИАНе **/
  cianId?: number | null;
  /** ID пользователя в ЦИАНе **/
  cianUserId?: number | null;
  /** Количество совместных санузлов **/
  combinedWcsCount?: number | null;
  /** Информация о собственности коммерческого объекта **/
  commercialOwnership?: ICommercialOwnershipSchema | null;
  /** Состояние **/
  conditionRatingType?: EConditionRatingType | null;
  /** Состояние **/
  conditionType?: EConditionType | null;
  /** Информация о коворкинге **/
  coworking?: ICoworkingSchema | null;
  /** Тип помещения в коворкинге **/
  coworkingOfferType?: ECoworkingOfferType | null;
  deadline?: IDeadlineSchema | null;
  /** Кто платит комиссию в сделке v2 **/
  dealRentMonetization?: EDealRentMonetization | null;
  /** Версия сделки в аренде **/
  dealRentVersion?: EDealRentVersion | null;
  /** Тип сделки **/
  dealType: EDealType;
  /** Отделка **/
  decoration?: EDecoration | null;
  /** Дом подлежит сносу в рамках программы реновации **/
  demolishedInMoscowProgramm?: boolean | null;
  /** Текст объявления **/
  description?: string | null;
  /** Канализация **/
  drainage?: IDrainageSchema | null;
  /** Объем, м3/сутки **/
  drainageCapacity?: number | null;
  /** Тип канализации **/
  drainageType?: EDrainageType | null;
  /** Подъездные пути **/
  drivewayType?: EDrivewayType | null;
  /** Номер группы дубликатов **/
  duplicateGroupId?: number | null;
  /** Ссылка на редактирование оффера, старая форма **/
  edit?: string | null;
  /** Дата смены статуса объявления **/
  editDate?: string | null;
  /** Ссылка на редактирование фото **/
  editPhoto?: string | null;
  /** Электроснабжение **/
  electricity?: IElectricitySchema | null;
  /** Мощность, кВТ **/
  electricityPower?: number | null;
  /** Тип электроснабжения **/
  electricityType?: EElectricityType | null;
  /** Недвижимость **/
  estateType?: EEstateType | null;
  /** Ссылки для экспорта **/
  exportLinks?: IExportLinksSchema | null;
  /** ID объявления во внешней системе **/
  externalId?: string | null;
  /** Ссылка на оригинальное объявление **/
  externalUrl?: string | null;
  /** Флаги состояния объявления **/
  flags?: IFlagsSchema | null;
  /** Тип квартиры **/
  flatType?: EFlatType | null;
  /** Этаж с **/
  floorFrom?: number | null;
  /** Материал полов **/
  floorMaterialType?: EFloorMaterialType | null;
  /** Этаж **/
  floorNumber?: number | null;
  /** План этажа и полигон квартиры **/
  floorPlan?: IESOfferFloorPlanSchema | null;
  /** Этаж по **/
  floorTo?: number | null;
  /** Мебель **/
  furniture?: string | null;
  /** Мебель **/
  furniturePresence?: EFurniturePresence | null;
  /** Тип гаража **/
  garage?: IGarageSchema | null;
  /** Газоснабжение **/
  gas?: IGasSchema | null;
  /** Емкость, м3/час **/
  gasCapacity?: number | null;
  /** Давление, Мпа **/
  gasPressure?: number | null;
  /** Тип газоснабжения **/
  gasType?: EGasType | null;
  /** ГЕО **/
  geo: IGeoSchema;
  /** Есть баня **/
  hasBathhouse?: boolean | null;
  /** Есть ванна **/
  hasBathtub?: boolean | null;
  /** Заселение 24 часа **/
  hasCheckIn_24?: boolean | null;
  /** Есть кондиционер **/
  hasConditioner?: boolean | null;
  /** Есть посудомоечная машина **/
  hasDishwasher?: boolean | null;
  /** Есть канализация **/
  hasDrainage?: boolean | null;
  /** Есть электричество **/
  hasElectricity?: boolean | null;
  /** Есть обременение **/
  hasEncumbrances?: boolean | null;
  /** Есть оборудование **/
  hasEquipment?: boolean | null;
  /** Организация экскурсий **/
  hasExcursions?: boolean | null;
  /** Есть система пожаротушения **/
  hasExtinguishingSystem?: boolean | null;
  /** Объявление имеет цену, близкую к среднерыночной **/
  hasFairPrice?: boolean | null;
  /** Есть холодильник **/
  hasFridge?: boolean | null;
  /** Есть мебель (в комнатах для живой) **/
  hasFurniture?: boolean | null;
  /** Есть гараж **/
  hasGarage?: boolean | null;
  /** Есть газ **/
  hasGas?: boolean | null;
  /** Фен **/
  hasHairdryer?: boolean | null;
  /** Есть отопление **/
  hasHeating?: boolean | null;
  /** Есть интернет **/
  hasInternet?: boolean | null;
  /** Есть инвестпроект **/
  hasInvestmentProject?: boolean | null;
  /** Утюг **/
  hasIron?: boolean | null;
  /** Джакузи **/
  hasJacuzzi?: boolean | null;
  /** Есть мебель на кухне **/
  hasKitchenFurniture?: boolean | null;
  /** Есть лифт **/
  hasLift?: boolean | null;
  /** Есть свет **/
  hasLight?: boolean | null;
  /** Есть парковка **/
  hasParking?: boolean | null;
  /** Есть телефон **/
  hasPhone?: boolean | null;
  /** Есть бассейн **/
  hasPool?: boolean | null;
  /** Пандус (есть/нет) **/
  hasRamp?: boolean | null;
  /** Ответственное хранение **/
  hasSafeCustody?: boolean | null;
  /** Документы командированным **/
  hasSecondedDocs?: boolean | null;
  /** Есть охрана **/
  hasSecurity?: boolean | null;
  /** Есть витринные окна **/
  hasShopWindows?: boolean | null;
  /** Есть душевая кабина **/
  hasShower?: boolean | null;
  /** Чай-кофе-сахар **/
  hasTeaCoffeeSugar?: boolean | null;
  /** Трансфер **/
  hasTransfer?: boolean | null;
  /** Транспортные услуги **/
  hasTransportServices?: boolean | null;
  /** Есть телевизор **/
  hasTv?: boolean | null;
  /** Есть стиральная машина **/
  hasWasher?: boolean | null;
  /** Есть водоснабжение **/
  hasWater?: boolean | null;
  /** Есть Wi-Fi **/
  hasWifi?: boolean | null;
  /** Платные ТВ-каналы **/
  hasWiredInternet?: boolean | null;
  /** Список всех проверок, которые прошел собственник **/
  homeownerProofs?: EHomeownerProofs[] | null;
  /** ID объявления в Realty **/
  id?: number | null;
  /** Вход **/
  inputType?: EInputType | null;
  /** Апартаменты **/
  isApartments?: boolean | null;
  /** Объявление от собственника коммерческой **/
  isByCommercialOwner?: boolean | null;
  /** Объявление от собственника **/
  isByHomeowner?: boolean | null;
  /** Партнер ли ЦИАН **/
  isCianPartner?: boolean | null;
  /** Объект в зоне ограниченной видимости **/
  isClosedVisibility?: boolean | null;
  /** Таможня **/
  isCustoms?: boolean | null;
  /** Объявление в сделке v2 offline **/
  isDealRentOffline?: boolean | null;
  /** Осуществлялась ли подмена номера для сделки **/
  isDealRequestSubstitutionPhone?: boolean | null;
  /** Является ли дубликатом **/
  isDuplicate?: boolean | null;
  /** Подключен ли колтрекинг **/
  isEnabledCallTracking?: boolean | null;
  /** Является ли объявлением от застройщика (застройщик, не представитель) **/
  isFromBuilder?: boolean | null;
  /** Является ли объявлением от представителя фабрики лидов **/
  isFromLeadFactory?: boolean | null;
  /** Является ли объявлением от представителя застройщика **/
  isFromSeller?: boolean | null;
  /** Является ли объявление импортированным **/
  isImported?: boolean | null;
  /** Объявление закрытой базы **/
  isInHiddenBase?: boolean | null;
  /** Юр. адрес предоставляется (да/нет) **/
  isLegalAddressProvided?: boolean | null;
  /** Скрывать точный адрес для отображения **/
  isNeedHideExactAddress?: boolean | null;
  /** Объект скрыт **/
  isObjectHidden?: boolean | null;
  /** Помещение занято **/
  isOccupied?: boolean | null;
  /** Пентхаус **/
  isPenthouse?: boolean | null;
  /** Сдается ли в аренду частями **/
  isRentByParts?: boolean | null;
  /** Является ли объявление вторичкой (только для загородки) **/
  isResale?: boolean | null;
  /** Признак уникальности объявления **/
  isUnique?: boolean | null;
  /** Дата исследования для признака уникальности объявления **/
  isUniqueCheckDate?: string | null;
  /** Признак уникальности объявления Коммерческой **/
  isUniqueForCian?: boolean | null;
  /** Площадь кухни, м2 **/
  kitchenArea?: string | null;
  /** Информация о коттеджном посёлке (только для загородки) **/
  kp?: ISimpleVillageSchema | null;
  /** Информация об участке **/
  land?: ILandSchema | null;
  /** Планировка **/
  layout?: ELayout | null;
  /** Инфраструктура и досуг **/
  leisure?: string | null;
  /** Жилая площадь, м2 **/
  livingArea?: string | null;
  /** Количество лоджий **/
  loggiasCount?: number | null;
  /** Площадь до **/
  maxArea?: string | null;
  /** Площадь от **/
  minArea?: string | null;
  /** Цена за весь объект за минимальную возможную площадь **/
  minPriceTotal?: number | null;
  /** Цена за весь объект в месяц за минимальную возможную площадь **/
  minPriceTotalPerMonth?: number | null;
  /** Цена за весь объект в месяц за минимальную возможную площадь **/
  minPriceTotalPerMonthRur?: number | null;
  /** Цена за весь объект за минимальную возможную площадь **/
  minPriceTotalRur?: number | null;
  /** НДС за весь объект в месяц за минимальную возможную площадь **/
  minVatPriceTotalPerMonthRur?: number | null;
  /** НДС за весь объект за минимальную возможную площадь **/
  minVatPriceTotalRur?: number | null;
  /** Данные модерации для отображения **/
  moderationInfo?: IModerationInfoSchema | null;
  /** Месячная прибыль **/
  monthlyIncome?: IMonthlyIncomeSchema | null;
  /** Наименование **/
  name?: string | null;
  /** Ссылка на редактирование оффера **/
  newEdit?: string | null;
  /** Информация о новостройке **/
  newbuilding?: INewBuildingSchema | null;
  /** Временный ID объявления/черновика (GUID) **/
  objectGuid?: string | null;
  /** Тип недвижимости **/
  offerType: EOfferType;
  /** Кол-во пассажирских лифтов **/
  passengerLiftsCount?: number | null;
  /** Вид разрешенного использования (ВРИ) **/
  permittedUseType?: EPermittedUseType | null;
  /** Можно с животными **/
  petsAllowed?: boolean | null;
  /** Кол-во телефонных линий **/
  phoneLinesCount?: number | null;
  /** Телефоны **/
  phones?: IPhoneSchema[] | null;
  /** Фотографии объекта **/
  photos?: IPhotoSchema[] | null;
  /** Тип помещения **/
  placementType?: EPlacementType | null;
  /** Возможно изменить ВРИ **/
  possibleToChangePermittedUseType?: boolean | null;
  /** Цена за единицу площади **/
  pricePerUnitArea?: number | null;
  /** Цена за единицу площади **/
  pricePerUnitAreaEur?: number | null;
  /** Цена за кв.м. в месяц **/
  pricePerUnitAreaPerMonth?: number | null;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYear?: number | null;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYearEur?: number | null;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYearRur?: number | null;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYearUsd?: number | null;
  /** Цена за единицу площади **/
  pricePerUnitAreaRur?: number | null;
  /** Цена за единицу площади **/
  pricePerUnitAreaUsd?: number | null;
  /** Цена за весь объект **/
  priceTotal?: number | null;
  /** Цена за весь объект **/
  priceTotalEur?: number | null;
  /** Цена за весь объект в месяц **/
  priceTotalPerMonth?: number | null;
  /** Цена за весь объект в месяц **/
  priceTotalPerMonthEur?: number | null;
  /** Цена за весь объект в месяц **/
  priceTotalPerMonthRur?: number | null;
  /** Цена за весь объект в месяц **/
  priceTotalPerMonthUsd?: number | null;
  /** Цена за весь объект **/
  priceTotalRur?: number | null;
  /** Цена за весь объект **/
  priceTotalUsd?: number | null;
  /** Цены за кв.м. по валютам **/
  pricesPerSquareMeter?: IPriceSchema | null;
  /** Цены за кв.м. в год по валютам **/
  pricesPerSquareMeterPerYear?: IPriceSchema | null;
  /** Проектная декларация **/
  projectDeclarationUrl?: string | null;
  /** Текст промо **/
  promoLabel?: string | null;
  /** Тип недвижимости **/
  propertyType?: EPropertyType | null;
  /** Дата публикации **/
  publicationDate?: number | null;
  /** Условия размещения объявления **/
  publishTerms?: IPublishTermsSchema | null;
  /** Realty ID пользователя, из под которого показывается объявление **/
  publishedUserId?: number | null;
  /** Тип готового бизнеса **/
  readyBusinessType?: EReadyBusinessType | null;
  /** Ссылка на восстановление объявления **/
  recoveryLink?: string | null;
  /** Описание сдачи части в аренду **/
  rentByPartsDescription?: string | null;
  /** Тип ремонта **/
  repairType?: ERepairType | null;
  /** Площадь комнаты (комната, койко-место) **/
  roomArea?: string | null;
  /** Тип комнаты (комната) **/
  roomType?: ERoomType | null;
  /** Площадь комнат **/
  roomsArea?: string | null;
  /** Количество комнат **/
  roomsCount?: number | null;
  /** Количество комнат в продажу/аренду **/
  roomsForSaleCount?: number | null;
  /** Статус проверки собственника в Росреестре **/
  rosreestrCheck?: IOfferRosreestrCheckSchema | null;
  /** Количество раздельных санузлов **/
  separateWcsCount?: number | null;
  /** Название коттеджного поселка **/
  settlementName?: string | null;
  /** Размер доли (доля в квартире, доля в доме) **/
  shareAmount?: string | null;
  /** Показывать ли предупреждение о недопустимости предоплаты **/
  showWarningMessage?: boolean | null;
  /** Кол-во похожих объявлений на других этажах **/
  similarOffersCount?: number | null;
  /** Ссылка на похожие объявления на других этажах **/
  similarOffersLink?: string | null;
  /** Возможное назначение **/
  specialty?: ICommercialSpecialtySchema | null;
  /** Статус объявления **/
  status: EStatus;
  /** Номер налоговой **/
  taxNumber?: number | null;
  /** Таймзона в часах **/
  timezone?: number | null;
  /** Заголовок объявления **/
  title?: string | null;
  /** Общая площадь, м2 **/
  totalArea?: string | null;
  /** Данные для трекинга **/
  trackingData?: ITrackingDataSchema | null;
  /** Пользователь подтвердил исправления нарушений **/
  userConfirmedFix?: boolean | null;
  /** ID пользователя в Realty **/
  userId?: number | null;
  /** Программа доверия **/
  userTrust?: string | null;
  /** Программа доверия **/
  userTrustLevel?: EUserTrustLevel | null;
  /** VAS **/
  valueAddedServices?: IValueAddedServicesSchema | null;
  /** НДС за весь объект в месяц **/
  vatPriceTotalPerMonthRur?: number | null;
  /** НДС за весь объект **/
  vatPriceTotalRur?: number | null;
  /** Список добавленных видео **/
  videos?: IVideoSchema[] | null;
  /** Возможна сельская ипотека **/
  villageMortgageAllowed?: boolean | null;
  /** Водоснабжение **/
  water?: IWaterSchema | null;
  /** Объем, м3/сутки **/
  waterCapacity?: number | null;
  /** Кол-во мокрых точек **/
  waterPipesCount?: number | null;
  /** Тип водоснабжения **/
  waterType?: EWaterType | null;
  /** Расположение санузла **/
  wcLocationType?: EWcLocationType | null;
  /** Тип санузла (комната) **/
  wcType?: EWcType | null;
  /** Куда выходят окна **/
  windowsViewType?: EWindowsViewType | null;
  /** Информация о доступности специалиста **/
  workTimeInfo?: IWorkTimeInfoSchema | null;
  /** Количество рабочих мест в помещении **/
  workplaceCount?: number | null;
}

export enum EAccessType {
  /** Свободный **/
  Free = 'free',
  /** Пропускная система **/
  PassSystem = 'passSystem',
}
export enum ECallTrackingProvider {
  /** Билайн **/
  Beeline = 'beeline',
  /** МТС **/
  Mts = 'mts',
  /** MTT **/
  Mtt = 'mtt',
}
export enum ECategory {
  /** Аренда койко-места **/
  BedRent = 'bedRent',
  /** Аренда здания **/
  BuildingRent = 'buildingRent',
  /** Продажа здания **/
  BuildingSale = 'buildingSale',
  /** Аренда готового бизнеса **/
  BusinessRent = 'businessRent',
  /** Продажа готового бизнеса **/
  BusinessSale = 'businessSale',
  /** Аренда автосервис **/
  CarServiceRent = 'carServiceRent',
  /** Продажа автосервиса **/
  CarServiceSale = 'carServiceSale',
  /** Аренда коммерческой земли **/
  CommercialLandRent = 'commercialLandRent',
  /** Продажа коммерческой земли **/
  CommercialLandSale = 'commercialLandSale',
  /** Аренда коттеджа **/
  CottageRent = 'cottageRent',
  /** Продажа коттеджа **/
  CottageSale = 'cottageSale',
  /** Посуточная аренда койко-места **/
  DailyBedRent = 'dailyBedRent',
  /** Посуточная аренда квартиры **/
  DailyFlatRent = 'dailyFlatRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  DailyHouseRent = 'dailyHouseRent',
  /** Посуточная аренда комнаты **/
  DailyRoomRent = 'dailyRoomRent',
  /** Аренда помещения под бытовые услуги **/
  DomesticServicesRent = 'domesticServicesRent',
  /** Продажа помещения под бытовые услуги **/
  DomesticServicesSale = 'domesticServicesSale',
  /** Аренда квартиры **/
  FlatRent = 'flatRent',
  /** Продажа квартиры **/
  FlatSale = 'flatSale',
  /** Продажа доли в квартире **/
  FlatShareSale = 'flatShareSale',
  /** Аренда помещения свободного назначения **/
  FreeAppointmentObjectRent = 'freeAppointmentObjectRent',
  /** Продажа помещения свободного назначения **/
  FreeAppointmentObjectSale = 'freeAppointmentObjectSale',
  /** Аренда гаража **/
  GarageRent = 'garageRent',
  /** Продажа гаража **/
  GarageSale = 'garageSale',
  /** Аренда дома/дачи **/
  HouseRent = 'houseRent',
  /** Продажа дома/дачи **/
  HouseSale = 'houseSale',
  /** Аренда части дома **/
  HouseShareRent = 'houseShareRent',
  /** Продажа части дома **/
  HouseShareSale = 'houseShareSale',
  /** Аренда производства **/
  IndustryRent = 'industryRent',
  /** Продажа производство **/
  IndustrySale = 'industrySale',
  /** Продажа участка **/
  LandSale = 'landSale',
  /** Продажа квартиры в новостройке **/
  NewBuildingFlatSale = 'newBuildingFlatSale',
  /** Аренда офиса **/
  OfficeRent = 'officeRent',
  /** Продажа офиса **/
  OfficeSale = 'officeSale',
  /** Аренда общепита **/
  PublicCateringRent = 'publicCateringRent',
  /** Продажа общепита **/
  PublicCateringSale = 'publicCateringSale',
  /** Аренда комнаты **/
  RoomRent = 'roomRent',
  /** Продажа комнаты **/
  RoomSale = 'roomSale',
  /** Аренда торговой площади **/
  ShoppingAreaRent = 'shoppingAreaRent',
  /** Продажа торговой площади **/
  ShoppingAreaSale = 'shoppingAreaSale',
  /** Аренда таунхауса **/
  TownhouseRent = 'townhouseRent',
  /** Продажа таунхауса **/
  TownhouseSale = 'townhouseSale',
  /** Аренда склада **/
  WarehouseRent = 'warehouseRent',
  /** Продажа склада **/
  WarehouseSale = 'warehouseSale',
}
export enum EConditionRatingType {
  /** Отличное **/
  Excellent = 'excellent',
  /** Хорошее **/
  Good = 'good',
  /** Удовлетворительное **/
  Satisfactory = 'satisfactory',
}
export enum EConditionType {
  /** Требуется косметический ремонт **/
  CosmeticRepairsRequired = 'cosmeticRepairsRequired',
  /** Дизайнерский ремонт **/
  Design = 'design',
  /** Под чистовую отделку **/
  Finishing = 'finishing',
  /** Требуется капитальный ремонт **/
  MajorRepairsRequired = 'majorRepairsRequired',
  /** Офисная отделка **/
  Office = 'office',
  /** Типовой ремонт **/
  Typical = 'typical',
}
export enum ECoworkingOfferType {
  /** Конференц-зал **/
  ConferenceHall = 'conferenceHall',
  /** Закрепленное рабочее место **/
  FixedWorkplace = 'fixedWorkplace',
  /** Незакрепленное рабочее место **/
  FlexibleWorkplace = 'flexibleWorkplace',
  /** Переговорная комната **/
  MeetingRoom = 'meetingRoom',
  /** Офис **/
  Office = 'office',
}
export enum EDealRentMonetization {
  /** Комиссию платит собственник **/
  FeeByHomeowner = 'feeByHomeowner',
  /** Комиссию платит арендатор **/
  FeeByRenter = 'feeByRenter',
  /** Комиссия включена в цену объявления **/
  FeeIncludedInOfferPrice = 'feeIncludedInOfferPrice',
}
export enum EDealRentVersion {
  /**  **/
  V1 = 'v1',
  /**  **/
  V2 = 'v2',
}
export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}
export enum EDecoration {
  /** Чистовая **/
  Fine = 'fine',
  /** Чистовая с мебелью **/
  FineWithFurniture = 'fineWithFurniture',
  /** Предчистовая **/
  PreFine = 'preFine',
  /** Черновая **/
  Rough = 'rough',
  /** Под ключ **/
  Turnkey = 'turnkey',
  /** Отделка неизвестна **/
  Unknown = 'unknown',
  /** Без отделки **/
  Without = 'without',
}
export enum EDrainageType {
  /** 'Автономная **/
  Autonomous = 'autonomous',
  /** 'Центральная **/
  Central = 'central',
  /** Выгребная яма **/
  Cesspool = 'cesspool',
  /** 'Септик **/
  SepticTank = 'septicTank',
  /** 'Ливневая **/
  Storm = 'storm',
  /** 'Очистные сооружения **/
  TreatmentFacilities = 'treatmentFacilities',
}
export enum EDrivewayType {
  /** Асфальтированная дорога **/
  Asphalt = 'asphalt',
  /** Грунтовая дорога **/
  Ground = 'ground',
  /** Нет **/
  No = 'no',
}
export enum EElectricityType {
  /** По границе участка **/
  Border = 'border',
  /** На участке **/
  Location = 'location',
  /** Нет **/
  No = 'no',
}
export enum EEstateType {
  /** В собственности **/
  Owned = 'owned',
  /** В аренде **/
  Rent = 'rent',
}
export enum EFlatType {
  /** Свободная планировка **/
  OpenPlan = 'openPlan',
  /** Комнаты **/
  Rooms = 'rooms',
  /** Студия **/
  Studio = 'studio',
}
export enum EFloorMaterialType {
  /** Асфальт **/
  Asphalt = 'asphalt',
  /** Бетон **/
  Concrete = 'concrete',
  /** Ламинат **/
  Laminate = 'laminate',
  /** Линолеум **/
  Linoleum = 'linoleum',
  /** Полимерный **/
  Polymeric = 'polymeric',
  /** Железобетон **/
  ReinforcedConcrete = 'reinforcedConcrete',
  /** Наливной пол **/
  SelfLeveling = 'selfLeveling',
  /** Плитка **/
  Tile = 'tile',
  /** Дерево **/
  Wood = 'wood',
}
export enum EFurniturePresence {
  /** Нет **/
  No = 'no',
  /** По желанию **/
  Optional = 'optional',
  /** Есть **/
  Yes = 'yes',
}
export enum EGasType {
  /** По границе участка **/
  Border = 'border',
  /** На участке **/
  Location = 'location',
  /** Нет **/
  No = 'no',
}
export enum EHomeownerProofs {
  /** Паспорт **/
  Passport = 'passport',
  /** Пользователь прошел проверку в Росреестре **/
  Rosreestr = 'rosreestr',
  /** Пользователь сдает как самозанятый **/
  SelfEmployed = 'selfEmployed',
}
export enum EInputType {
  /** Общий с улицы **/
  CommonFromStreet = 'commonFromStreet',
  /** Общий со двора **/
  CommonFromYard = 'commonFromYard',
  /** Отдельный с улицы **/
  SeparateFromStreet = 'separateFromStreet',
  /** Отдельный со двора **/
  SeparateFromYard = 'separateFromYard',
}
export enum ELayout {
  /** Кабинетная **/
  Cabinet = 'cabinet',
  /** Коридорная **/
  Corridorplan = 'corridorplan',
  /** Смешанная **/
  Mixed = 'mixed',
  /** Открытая **/
  OpenSpace = 'openSpace',
}
export enum EOfferType {
  /** коммерческая **/
  Commercial = 'commercial',
  /** квартиры **/
  Flat = 'flat',
  /** новостройки **/
  Newobject = 'newobject',
  /** загородка **/
  Suburban = 'suburban',
}
export enum EPermittedUseType {
  /** Cельскохозяйственное использование **/
  Agricultural = 'agricultural',
  /** Деловое управление **/
  BusinessManagement = 'businessManagement',
  /** Общее пользование территории **/
  CommonUseArea = 'commonUseArea',
  /** Высотная застройка **/
  HighriseBuildings = 'highriseBuildings',
  /** Гостиничное обслуживание **/
  HotelAmenities = 'hotelAmenities',
  /** Индивидуальное жилищное строительство (ИЖС) **/
  IndividualHousingConstruction = 'individualHousingConstruction',
  /** Промышленность **/
  Industry = 'industry',
  /** Отдых (рекреация) **/
  Leisure = 'leisure',
  /** Малоэтажное жилищное строительство (МЖС) **/
  LowriseHousing = 'lowriseHousing',
  /** Общественное использование объектов капитального строительств **/
  PublicUseOfCapitalConstruction = 'publicUseOfCapitalConstruction',
  /** Обслуживание автотранспорта **/
  ServiceVehicles = 'serviceVehicles',
  /** Торговые центры **/
  ShoppingCenters = 'shoppingCenters',
  /** Склады **/
  Warehouses = 'warehouses',
}
export enum EPlacementType {
  /** Помещение в торговом комплексе **/
  ShoppingMall = 'shoppingMall',
  /** Street retail **/
  StreetRetail = 'streetRetail',
}
export enum EPropertyType {
  /** здание **/
  Building = 'building',
  /** помещение свободного назначения **/
  FreeAppointment = 'freeAppointment',
  /** гараж **/
  Garage = 'garage',
  /** производство **/
  Industry = 'industry',
  /** земля **/
  Land = 'land',
  /** офис **/
  Office = 'office',
  /** торговая площадь **/
  ShoppingArea = 'shoppingArea',
  /** склад **/
  Warehouse = 'warehouse',
}
export enum EReadyBusinessType {
  /** Другое (например, автосервис, аптека, химчистка) **/
  Other = 'other',
  /** Готовый бизнес **/
  ReadyBusiness = 'readyBusiness',
  /** Арендный бизнес **/
  RentalBusiness = 'rentalBusiness',
}
export enum ERepairType {
  /** Косметический **/
  Cosmetic = 'cosmetic',
  /** Дизайнерский **/
  Design = 'design',
  /** Евроремонт **/
  Euro = 'euro',
  /** Без ремонта **/
  No = 'no',
}
export enum ERoomType {
  /** Оба варианта **/
  Both = 'both',
  /** Смежная **/
  Combined = 'combined',
  /** Изолированная **/
  Separate = 'separate',
}
export enum EStatus {
  /** Заблокировано **/
  Blocked = 'blocked',
  /** Деактивировано **/
  Deactivated = 'deactivated',
  /** Удалено **/
  Deleted = 'deleted',
  /** Черновик **/
  Draft = 'draft',
  /** Промодерировано **/
  Moderate = 'moderate',
  /** Опубликовано **/
  Published = 'published',
  /** Отклонено **/
  Refused = 'refused',
  /** Удалено модератором **/
  RemovedByModerator = 'removedByModerator',
  /** Продано **/
  Sold = 'sold',
}
export enum EUserTrustLevel {
  /** Очень много жалоб **/
  Danger = 'danger',
  /** Исключен из программы **/
  Excluded = 'excluded',
  /** участвует **/
  Involved = 'involved',
  /** Новый пользователь **/
  New = 'new',
  /** не участвует **/
  NotInvolved = 'notInvolved',
}
export enum EWaterType {
  /** Автономное **/
  Autonomous = 'autonomous',
  /** Центральное **/
  Central = 'central',
  /** Водонапорная станция **/
  PumpingStation = 'pumpingStation',
  /** Водозаборный узел **/
  WaterIntakeFacility = 'waterIntakeFacility',
  /** Водонапорная башня **/
  WaterTower = 'waterTower',
}
export enum EWcLocationType {
  /** В доме **/
  Indoors = 'indoors',
  /** На улице **/
  Outdoors = 'outdoors',
}
export enum EWcType {
  /** Совмещенный **/
  Combined = 'combined',
  /** Раздельный **/
  Separate = 'separate',
}
export enum EWindowsViewType {
  /** На улицу **/
  Street = 'street',
  /** Во двор **/
  Yard = 'yard',
  /** На улицу и двор **/
  YardAndStreet = 'yardAndStreet',
}
